export const ELEMENTS_TYPES = {
  ICON: 'Icon',
  IMAGE: 'Image',
  IMAGE_CAPTION: 'Image Caption',
  INTRO_TEXT: 'Intro Text',
  SECTION_NAME: 'Section Name',
  SECTION_NUMBER: 'Section Number',
  TITLE: 'Title',
};